import { useLocation, useNavigate } from "react-router";

import { MessageSquareIcon } from "lucide-react";

import { Button } from "simplydo/react/ui/button";
import { Icon } from "simplydo/react/ui/icon";

import type { IdeaWithOwnerChallenge } from "../types";

type ScrollToCommentsActionProps = { idea: IdeaWithOwnerChallenge };

const ScrollToCommentsAction = ({ idea }: ScrollToCommentsActionProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (idea?.ownerChallenge?.preventIdeaComments) {
    return null;
  }

  return (
    <Button
      tooltip={"Scroll to comments"}
      style={{ position: "relative" }}
      className="is-icon"
      onClick={() => {
        navigate(location.search + "#comments");
      }}
    >
      <Icon icon={MessageSquareIcon} />
      {idea.commentCount ? (
        <div
          style={{
            position: "absolute",
            right: 3,
            bottom: 0,
            opacity: 0.9,
            fontSize: 10,
          }}
        >
          {idea.commentCount || 0}
        </div>
      ) : null}
    </Button>
  );
};

export default ScrollToCommentsAction;
